// Agent roster — one entry per signal family the trading floor team uses.
// Unknown families fall back to { name: family, specialty: '', color: '#9ea4d8' }.
export const AGENT_DISPLAY = {
  FLOW: {
    name: 'Flow Analyst',
    specialty: 'Detects on-chain token flow anomalies',
    color: '#5eb8ff',
  },
  E3D_CANDIDATE: {
    name: 'E3D Screener',
    specialty: 'Surfaces tokens meeting E3D acquisition criteria',
    color: '#a78bfa',
  },
  WHALE: {
    name: 'Whale Tracker',
    specialty: 'Monitors large-wallet positioning changes',
    color: '#34d399',
  },
  SECURITY_RISK: {
    name: 'Risk Sentinel',
    specialty: 'Flags contract anomalies and rug-pull signals',
    color: '#f87171',
  },
  BREAKOUT_CONFIRMED: {
    name: 'Breakout Scout',
    specialty: 'Confirms technical breakout setups',
    color: '#fbbf24',
  },
};

export function agentMeta(family) {
  return AGENT_DISPLAY[String(family || '')] || {
    name: String(family || 'Unknown'),
    specialty: '',
    color: '#9ea4d8',
  };
}

export const intelligencePalette = {
  background: 'rgba(10, 14, 30, 0.92)',
  panel: 'rgba(12, 18, 36, 0.94)',
  border: 'rgba(77, 121, 255, 0.22)',
  borderStrong: 'rgba(77, 121, 255, 0.45)',
  text: '#e5e7ff',
  muted: '#9ea4d8',
  positive: '#9ef7c5',
  action: '#4d79ff',
  danger: '#ff7a8a',
  amber: '#f2c879',
  chipMuted: 'rgba(158, 164, 216, 0.18)',
  chipBlue: 'rgba(77, 121, 255, 0.18)',
  chipGreen: 'rgba(158, 247, 197, 0.18)',
  chipAmber: 'rgba(242, 200, 121, 0.18)',
  chipRed: 'rgba(255, 122, 138, 0.18)',
};

export function getChipTone(kind) {
  const value = String(kind || '').toLowerCase().replace(/\s+/g, '_');
  if (['confirmed', 'fresh', 'buy', 'paper_buy', 'improving', 'fixed'].includes(value)) {
    return {
      color: intelligencePalette.positive,
      background: intelligencePalette.chipGreen,
      borderColor: 'rgba(158, 247, 197, 0.35)',
    };
  }
  if (['watch', 'exit', 'paper_exit', 'stable', 'schema_guard_added'].includes(value)) {
    return {
      color: '#9ec4ff',
      background: intelligencePalette.chipBlue,
      borderColor: 'rgba(77, 121, 255, 0.35)',
    };
  }
  if (['weak', 'aging', 'wait', 'flat', 'in_retrain'].includes(value)) {
    return {
      color: intelligencePalette.amber,
      background: intelligencePalette.chipAmber,
      borderColor: 'rgba(242, 200, 121, 0.35)',
    };
  }
  if (['decaying', 'stale', 'retraining_target'].includes(value)) {
    return {
      color: intelligencePalette.danger,
      background: intelligencePalette.chipRed,
      borderColor: 'rgba(255, 122, 138, 0.35)',
    };
  }
  return {
    color: intelligencePalette.muted,
    background: intelligencePalette.chipMuted,
    borderColor: 'rgba(158, 164, 216, 0.22)',
  };
}

export function createPanelStyle(extra = {}) {
  return {
    background: intelligencePalette.panel,
    border: `1px solid ${intelligencePalette.border}`,
    borderRadius: 20,
    boxShadow: '0 18px 48px rgba(0, 0, 0, 0.25)',
    color: intelligencePalette.text,
    ...extra,
  };
}
